module.exports = __webpack_public_path__ + "img/tournaments_select.f05a843b.svg";